import { MutationTree } from 'vuex'
import { PartyRoom, PartyRoomState } from '@/types/PartyRoom'
import SongRequest from '@/types/SongRequest'

export const mutations: MutationTree<PartyRoomState> = {
  addSong (state, payload: SongRequest) {
    if (state.queue) state.queue.push(payload)
    else throw new Error('Queue was undefined when we tried to add song')
  },
  addVoteForNext (state, payload: string) {
    if (state.votesForNextSong) state.votesForNextSong.push(payload)
    else throw new Error('Votes for next song was undefined when we tried to add vote for next song')
  },
  clearRoom (state) {
    state.partyRoom = {
      partyID: '',
      name: '',
      votesForNext: 0,
      fallback: '',
      created: 0,
      host: '',
      playingPlaylist: false
    }
  },
  clearSongs (state) {
    state.queue = []
  },
  clearVotesForNext (state) {
    state.votesForNextSong = []
  },
  setPartyRoom (state, payload: PartyRoom) {
    state.partyRoom = payload
  }
}
